<template>
  <CreateCompanyContent>
    <section id="company_container">
      <input
        type="file"
        ref="file"
        accept="image/*"
        class="hide"
        @change="onChangeFile"
      />
      <div class="panel-content">
        <div class="left-panel">
          <div class="image-company" ref="imageCompany"></div>
          <vs-button
            icon="camera"
            color="primary"
            type="filled"
            class="btn-update-image mt-3"
            @click="openExplorer"
          >
            Actualizar logo
          </vs-button>
        </div>
        <div class="right-panel">
          <div class="columns">
            <div class="column" v-if="checkCompanyMain()">
              <b-field :label="`Empresa Padre${!editing ? ' *' : ''}`">
                <treeselect
                  :options="companies"
                  :show-count="true"
                  v-model="company"
                  name="company"
                  :v-validate="`${editing ? 'unrequired' : 'required'}`"
                  placeholder="Seleccione una empresa padre"
                />
              </b-field>
              <span class="show-error">{{ errors.first("company") }}</span>
            </div>
            <div class="column is-4">
              <b-field label="Clasificación *">
                <b-select
                  v-validate="'required'"
                  name="clasification"
                  placeholder="Seleccione una Clasificación"
                  expanded
                  v-model="clasification"
                >
                  <option
                    v-for="option in clasifications"
                    :value="option.id"
                    :key="option.id"
                    :id="option.id"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <span class="show-error">{{
                errors.first("clasification")
              }}</span>
            </div>
            <div class="column">
              <b-field label="Nombre Empresa *">
                <b-input
                  placeholder="Nombre Empresa"
                  type="text"
                  name="name"
                  v-model="name"
                  v-validate="'required'"
                >
                </b-input>
              </b-field>
              <span class="show-error">{{ errors.first("name") }}</span>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field label="Teléfonos">
                <b-input
                  v-validate="'required'"
                  placeholder="Teléfono"
                  type="text"
                  name="phone"
                  :value="phone"
                  disabled
                  expanded
                ></b-input>
                <b-button
                  class="button is-info is-light"
                  @click="openModal('phone')"
                  ><i class="mr-2 mdi mdi-tooltip-edit"></i
                ></b-button>
              </b-field>
              <span class="show-error">{{ errors.first("phone") }}</span>
            </div>
            <div class="column">
              <b-field label="Tipo de Identificación *">
                <b-select
                  name="idType"
                  v-validate="'required'"
                  placeholder="Seleccione un Tipo de Identificación"
                  expanded
                  v-model="idType"
                >
                  <option
                    v-for="option in idList"
                    :value="option.code"
                    :key="option.code"
                    :id="option.code"
                  >
                    {{ option.title }}
                  </option>
                </b-select>
              </b-field>
              <span class="show-error">{{ errors.first("idType") }}</span>
            </div>
            <div class="column">
              <b-field label="Identificación *">
                <div class="flex check-digit-container">
                  <b-input
                    name="identification"
                    placeholder="Identificación"
                    type="text"
                    v-model="identification"
                    v-validate="'required|numeric'"
                    class="input-default"
                  ></b-input>
                  <input
                    class="input digit"
                    placeholder="Dígito"
                    name="digit"
                    v-model="digit"
                    v-validate="'required|numeric'"
                    title="Dígito de verificación"
                  />
                </div>
              </b-field>
              <span class="show-error">{{
                errors.first("identification") || errors.first("digit")
              }}</span>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field label="Ciudad *">
                <Autocomplete
                  name="city"
                  :options="cities"
                  v-model="city"
                  placeholder="Buscar..."
                  @getCities="getCities"
                />
              </b-field>
              <span class="show-error" v-if="!city && validationStarted"
                >Es obligatorio</span
              >
            </div>
            <div class="column">
              <b-field label="Email">
                <b-input
                  placeholder="Emails"
                  type="text"
                  disabled
                  expanded
                  name="email"
                  v-validate="'required'"
                  :value="email"
                ></b-input>
                <b-button class="button is-info is-light" @click="openModal()"
                  ><i class="mr-2 mdi mdi-tooltip-edit"></i
                ></b-button>
              </b-field>
              <span class="show-error">{{ errors.first("email") }}</span>
            </div>
            <div class="column">
              <b-field label="Dirección *">
                <b-input
                  name="address"
                  placeholder="Dirección"
                  type="text"
                  v-model="address"
                  v-validate="'required'"
                ></b-input>
              </b-field>
              <span class="show-error">{{ errors.first("address") }}</span>
            </div>
          </div>
          <div class="columns" v-if="clasification == 'P'">
            <div class="column">
              <b-field label="Código de compañia *" class="mb-0">
                <b-input
                  name="companyCode"
                  placeholder="Código de compañia"
                  type="text"
                  v-model="companyCode"
                  v-validate="'required|numeric'"
                  maxlength="4"
                ></b-input>
              </b-field>
              <span class="show-error">{{ errors.first("companyCode") }}</span>
            </div>
            <div class="column">
              <b-field label="Código de parqueadero *" class="mb-0">
                <b-input
                  name="parkingCode"
                  placeholder="Código de parqueadero"
                  type="text"
                  v-model="parkingCode"
                  maxlength="5"
                  v-validate="'required|numeric'"
                ></b-input>
              </b-field>
              <span class="show-error">{{ errors.first("parkingCode") }}</span>
            </div>
            <div class="column"></div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="extra-info-content">
                <div class="widget">
                  <div class="widget-header">
                    <div class="header-info">
                      <label class="text-bold">Información adicional</label>
                      <p class="description">
                        Agrega aquí toda la información adicional como
                        promociones, días hábiles, horarios y demás información
                        que necesites.
                      </p>
                    </div>
                    <vs-button
                      class="mt-2"
                      color="primary"
                      icon="add"
                      type="filled"
                      @click="addAdditionalInfo()"
                    >
                      Agregar item
                    </vs-button>
                  </div>
                  <div class="widget-body">
                    <draggable v-model="extraInfoList">
                      <div
                        :class="`item-widget ${
                          extraInfoEditing != null &&
                          extraInfoEditing.index === option.index
                            ? 'selected'
                            : ''
                        }`"
                        v-for="option in extraInfoList"
                        :value="option.index"
                        :key="option.index"
                        :id="option.index"
                        v-on:click="editExtraInfo(option)"
                      >
                        <button
                          v-if="
                            extraInfoEditing != null &&
                            extraInfoEditing.index === option.index
                          "
                          title="Editar"
                          class="btn-float btn-edit"
                          @click="openExtraInfo(option)"
                        >
                          <i class="mdi mdi-pencil-outline"></i>
                        </button>
                        <button
                          title="Eliminar"
                          class="btn-float btn-remove"
                          @click="removeExtraInfo(option)"
                        >
                          &times;
                        </button>
                        <label class="item-title text-bold">{{
                          option.title
                        }}</label>
                        <p class="item-description">{{ option.value }}</p>
                      </div>
                    </draggable>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="map-container widget">
                <div class="info">
                  <label class="text-bold"
                    >Selecciona en el mapa las coordenadas de tu ubicación
                    *</label
                  >
                  <div class="columns mb-1">
                    <div class="column">
                      <b-field label="Latitud">
                        <b-input
                          expanded
                          placeholder="Latitud"
                          type="text"
                          v-model="latitude"
                          disabled
                        ></b-input>
                      </b-field>
                    </div>
                    <div class="column">
                      <b-field label="Longitud">
                        <b-input
                          placeholder="Longitud"
                          type="text"
                          v-model="longitude"
                          disabled
                        ></b-input>
                      </b-field>
                    </div>
                  </div>
                </div>
                <MapLayers />
              </div>
            </div>
          </div>
          <div class="buttons button-group">
            <vs-button
              color="primary"
              icon="save"
              type="filled"
              @click="save()"
            >
              Guardar
            </vs-button>
            <vs-button
              color="danger"
              v-if="idCompany != null"
              class="ml-2"
              icon="delete"
              type="filled"
              @click="openDeleteModal()"
            >
              Eliminar
            </vs-button>
          </div>
        </div>
      </div>
      <b-modal
        v-model="isCardModalActive"
        :width="850"
        scroll="keep"
        :on-cancel="onCancelModalEmailPhone"
      >
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head header-modal">
            <p class="modal-card-title" style="color: white">
              <i class="mr-2 mdi mdi-email"></i
              >{{
                modalPhone
                  ? "Agregar Teléfonos"
                  : "Agregar Correos Electrónicos"
              }}
            </p>
          </header>
          <section class="modal-card-body" v-if="!modalPhone">
            <vs-alert
              title="Error"
              :active="errorsModal.show"
              color="danger"
              class="mb-3"
            >
              {{ errorsModal.message }}
            </vs-alert>
            <div
              class="columns pl-3 pr-3 pt-3 pb-3"
              v-if="emails == null || emails.length === 0"
            >
              <b-button type="is-info" @click="addNewEmail()"
                ><i class="mdi mdi-plus"></i> Agregar correo</b-button
              >
            </div>
            <div class="columns" v-for="(email, index) in emails" :key="index">
              <div class="column">
                <b-field label="Correo:">
                  <b-input
                    expanded
                    type="email"
                    :value="email.email"
                    v-model="email.email"
                    required
                  >
                  </b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Tipo:">
                  <b-select
                    placeholder="Seleccione un Tipo de Correo"
                    v-model="email.type"
                    expanded
                  >
                    <option
                      v-for="option in emailTypes"
                      :value="option.id"
                      :key="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-one-fifth">
                <b-button
                  v-if="email.add"
                  type="is-info"
                  class="modal-button-custom"
                  @click="addNewEmail()"
                  ><i class="mdi mdi-plus"></i
                ></b-button>
                <b-button
                  type="is-danger"
                  class="modal-button-custom"
                  @click="deleteEmail(index)"
                  ><i class="mdi mdi-minus"></i></b-button>
              </div>
            </div>
          </section>
          <section class="modal-card-body" v-else>
            <vs-alert
              title="Danger"
              :active="errorsModal.show"
              color="danger"
              class="mb-3"
            >
              {{ errorsModal.message }}
            </vs-alert>
            <div
              class="columns pl-3 pr-3 pt-3 pb-3"
              v-if="phones == null || phones.length === 0"
            >
              <b-button type="is-info" @click="addNewPhone()"
                ><i class="mdi mdi-plus"></i> Agregar teléfono</b-button
              >
            </div>
            <div class="columns" v-for="(phone, index) in phones" :key="index">
              <div class="column">
                <b-field label="Teléfono:">
                  <b-input
                    expanded
                    type="text"
                    :value="phone.phone"
                    v-model="phone.phone"
                    required
                  >
                  </b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Tipo:">
                  <b-select
                    placeholder="Seleccione un Tipo de Telefono"
                    v-model="phone.type"
                    expanded
                  >
                    <option
                      v-for="option in emailTypes"
                      :value="option.id"
                      :key="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-one-fifth">
                <b-button
                  v-if="phone.add"
                  type="is-info"
                  class="modal-button-custom"
                  @click="addNewPhone()"
                  ><i class="mdi mdi-plus"></i
                ></b-button>
                <b-button
                  type="is-danger"
                  class="modal-button-custom"
                  @click="deletePhone(index)"
                  ><i class="mdi mdi-minus"></i
                ></b-button>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <b-button
              type="is-info"
              label="Aceptar"
              @click="modalPhone ? acceptNewPhones() : acceptNewEmails()"
            />
            <b-button
              type="is-danger"
              label="Cancelar"
              @click="modalPhone ? deletePhones() : deleteEmails()"
            />
          </footer>
        </div>
      </b-modal>
      <!-- use selected and fillData() -->
      <b-modal v-model="modalInfo" :width="850" scroll="keep">
        <div class="modal-card" style="width: auto" id="editModal">
          <header class="modal-card-head header-modal">
            <p class="modal-card-title" style="color: white">
              <i class="mr-2 mdi mdi-magnify"></i>Agregar Información Adicional
            </p>
          </header>
          <section class="modal-card-body" v-if="!modalPhone">
            <vs-alert
              title="Error"
              :active="errorsModalInfo.show"
              color="danger"
              class="mb-3"
            >
              {{ errorsModalInfo.message }}
            </vs-alert>

            <div class="columns">
              <div class="column">
                <b-field label="Tipo:">
                  <b-select
                    placeholder="Seleccione un tipo de valor"
                    v-model="extraInfoData.type"
                    expanded
                  >
                    <option
                      v-for="option in aditionalInfo"
                      :value="option.code"
                      :key="option.code"
                    >
                      {{ option.title }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Titulo">
                  <b-input
                    expanded
                    type="text"
                    :value="extraInfoData.title"
                    v-model="extraInfoData.title"
                    :disabled="extraInfoData.type == null"
                    required
                  >
                  </b-input>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="Descripción">
                  <b-input
                    expanded
                    type="textarea"
                    :value="extraInfoData.value"
                    v-model="extraInfoData.value"
                    :disabled="extraInfoData.type == null"
                    required
                  >
                  </b-input>
                </b-field>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <b-button
              type="is-info"
              label="Aceptar"
              @click="acceptExtraInfo()"
            />
            <b-button
              type="is-danger"
              label="Cancelar"
              @click="deleteInfoModal()"
            />
          </footer>
        </div>
      </b-modal>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    </section>
  </CreateCompanyContent>
</template>

<script>
import { CreateCompanyContent } from "./styles";
import { get as getProp } from "object-path";
import { validText } from "../../../global/validator";
import { ROUTES } from "../../../global/api_routes";
import { mapGetters } from "vuex";
import MapLayers from "../../../components/Map/MapLayers";
import mapTypes from "@/store/types/map";
import {
  confirmation,
  getFileUrlData,
  getUrlParameters,
} from "../../../global/utils";
import draggable from "vuedraggable";
import Autocomplete from "../../../components/Shared/Autocomplete";
import { configToast, TOAST_TYPES } from "../../../global/toast";
import { COMPANY_MAIN_CODE } from "../../../global/constants";

export default {
  name: "CreateCompany",
  components: { MapLayers, CreateCompanyContent, draggable, Autocomplete },
  computed: {
    ...mapGetters({
      latitude: mapTypes.getters.latitude,
      longitude: mapTypes.getters.longitude,
    }),
  },
  data: () => ({
    actualCode: null,
    name: "",
    validationStarted: "",
    extraInfoList: [],
    extraInfoData: { title: null, value: null, type: null },
    companyCode: null,
    parkingCode: null,
    company: null,
    clasification: null,
    identification: "",
    phone: "",
    editing: false,
    digit: "",
    infoLabel: "",
    address: "",
    email: "",
    city: null,
    idType: null,
    consultName: "",
    idCompany: null,
    selected: null,
    idList: [],
    companies: [],
    tableData: [],
    cities: [],
    aditionalInfo: [],
    emailTypes: [
      { name: "Personal", id: "P" },
      { name: "Trabajo", id: "W" },
      { name: "Otro", id: "O" },
    ],
    clasifications: [
      { name: "Parqueadero", id: "P" },
      { name: "Regional", id: "R" },
      { name: "Principal", id: "M" },
    ],
    emails: [],
    phones: [],
    extraInfo: [
      {
        title: null,
        value: null,
        order: null,
        type: null,
        add: true,
      },
    ],
    errorsModal: {
      message: "",
      show: false,
    },
    errorsModalInfo: {
      message: "",
      show: false,
    },
    isCardModalActive: false,
    modalPhone: false,
    editModal: false,
    isLoading: false,
    modalInfo: false,
    extraInfoEditing: null,
    lastFilled: null,
  }),
  watch: {
    company: function () {
      if (this.lastFilled === "modal") {
        this.lastFilled = "watch";
        return;
      }
      this.findCompany();
    },
    editModal: function () {
      if (!this.editModal) {
        return;
      }
      this.consultName = this.name;
      this.consultCompanies();
    },
  },
  mounted() {
    this.getTypes();
    this.getCompanies();
    this.getExtraInfo();
    this.checkEdition();
  },
  methods: {
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#company_container");
      return instance.open(message, type);
    },
    checkCompanyMain() {
      return this.actualCode != COMPANY_MAIN_CODE;
    },
    checkEdition() {
      const companyCode = getProp(getUrlParameters(), "code");
      if (!companyCode) {
        return;
      }
      this.editing = true;
      this.actualCode = companyCode;
      this.findCompany(companyCode);
    },
    openExplorer() {
      this.$refs.file.value = "";
      this.$refs.file.click();
    },
    getFile() {
      const files = this.$refs.file.files;
      if (!files || files.length == 0) {
        return;
      }
      const file = files[0];
      return file;
    },
    onChangeFile() {
      const file = this.getFile();
      getFileUrlData(file, (event) => {
        this.$refs.imageCompany.style.backgroundColor = "#FFFFFF";
        this.$refs.imageCompany.style.backgroundImage = `url(${event.target.result})`;
      });
    },
    uploadFile() {
      const formData = new FormData();
      const file = this.getFile();
      if (!file) {
        return;
      }
      formData.append("file", file);
      return new Promise((resolve, reject) => {
        this.$http
          .post(ROUTES.GLOBAL.UPLOAD_FILE, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(({ data }) => {
            if (data.code > 0) {
              resolve(data.info.code);
              return;
            }
            resolve(null);
          })
          .catch((error) => {
            resolve(null);
          });
      });
    },
    findCompany(company) {
      this.isLoading = true;
      this.$http
        .get(ROUTES.DASHBOARD.COMPANY.GET_BY_CODE, {
          params: {
            companyId: company || this.company,
          },
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.selected = data.info;
            this.fillData(!company);
            return;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addAdditionalInfo() {
      this.extraInfoData = {};
      this.openModal("info");
    },
    editExtraInfo(option) {
      this.extraInfoEditing = option;
    },
    openExtraInfo(option) {
      this.extraInfoData = option;
      this.openModal("info");
    },
    getChildCities(cities, city) {
      city.children = cities.filter(
        (item) => getProp(item, "father.code", item.father) == city.code
      );
      city.children.forEach((city) => {
        this.getChildCities(cities, city);
      });
    },
    groupCities(cities) {
      //Obtenemos los padres...
      const fathers = cities.filter(
        (item) => !getProp(item, "father.code", item.father)
      );
      fathers.forEach((city) => {
        //Buscamos los hijos de esto...
        this.getChildCities(cities, city);
      });
      return fathers;
    },
    removeExtraInfo(option) {
      const index = this.extraInfoList.findIndex(
        (item) =>
          item.index === option.index ||
          (item.code && item.code === option.code)
      );
      if (index < 0) {
        return;
      }
      confirmation(this, `¿Desea eliminar el registro?`).then((result) => {
        if (!result) {
          return;
        }
        const newList = [...this.extraInfoList];
        newList.splice(index, 1);
        this.extraInfoList = newList;
      });
    },
    processData(companies) {
      for (let index = 0; index < companies.length; index++) {
        let companie = companies[index];
        companie.label = companie.title ? companie.title : companie.name;
        companie.id = companie.code;
        if (companie.children) {
          this.processData(companie.children);
        }
      }
    },
    getCities({ action, searchQuery, callback }) {
      if (action === "ASYNC_SEARCH") {
        if (searchQuery.length < 2) {
          return;
        }
        this.$http
          .get(ROUTES.GLOBAL.GET_CITIES, {
            params: {
              search: searchQuery,
            },
          })
          .then(({ data }) => {
            if (data.code > 0) {
              this.cities = data.info;
              this.processData(this.cities);
              this.cities = this.groupCities(this.cities);
              callback(null, this.cities);
            } else {
              this.cities = [];
              callback(null, []);
            }
          });
      }
    },
    getExtraInfo() {
      this.$http.get(ROUTES.DASHBOARD.GET_EXTRA_INFO).then(({ data }) => {
        if (data.code > 0) {
          this.aditionalInfo = data.info;
        }
      });
    },
    getTypes() {
      this.$http
        .get(ROUTES.DASHBOARD.ENTITY.GET_LIST_BY_KIND, {
          params: {
            kindFather: 64,
            kindId: 1,
          },
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.idList = data.info;
          }
        });
    },
    getCompanies() {
      this.$http.get(ROUTES.DASHBOARD.GET_COMPANIES).then(({ data }) => {
        if (data.code > 0) {
          this.companies = data.info;
          this.processData(this.companies);
          this.companies = this.groupCities(this.companies);
        }
      });
    },
    deleteEmails() {
      this.emails = [
        {
          email: "",
          type: "",
          add: true,
        },
      ];
      this.isCardModalActive = false;
      this.errorsModal.message = "";
      this.errorsModal.show = false;
      this.email = "";
    },
    deleteInfoModal() {
      this.extraInfo = [
        {
          title: null,
          value: null,
          order: null,
          type: null,
          add: true,
        },
      ];
      this.errorsModalInfo.message = "";
      this.errorsModalInfo.show = false;
      this.modalInfo = false;
    },
    deletePhones() {
      this.phones = [
        {
          phone: "",
          type: "",
          add: true,
        },
      ];
      this.isCardModalActive = false;
      this.modalPhone = false;
      this.errorsModal.message = "";
      this.errorsModal.show = false;
      this.phone = "";
    },
    addNewEmail() {
      if (this.emails.length === 1) {
        this.emails[0].add = false;
      }
      if (this.emails.length > 1) {
        this.emails[this.emails.length - 1].add = false;
      }
      this.emails = [
        ...this.emails,
        {
          email: "",
          type: "",
          add: true,
        },
      ];
    },
    addNewPhone() {
      if (this.phones.length === 1) {
        this.phones[0].add = false;
      }
      if (this.phones.length > 1) {
        this.phones[this.phones.length - 1].add = false;
      }
      this.phones = [
        ...this.phones,
        {
          phone: "",
          type: "",
          add: true,
        },
      ];
    },
    addNewInfo() {
      if (this.extraInfo.length === 1) {
        this.extraInfo[0].add = false;
      }
      if (this.extraInfo.length > 1) {
        this.extraInfo[this.extraInfo.length - 1].add = false;
      }
      this.extraInfo = [
        ...this.extraInfo,
        {
          title: null,
          value: null,
          order: null,
          type: null,
          add: true,
        },
      ];
    },
    deleteEmail(index) {
      this.emails.splice(index, 1);
    },
    deletePhone(index) {
      this.phones.splice(index, 1);
    },
    deleteInfo(index) {
      this.extraInfo.splice(index, 1);
    },
    acceptNewEmails() {
      for (let index = 0; index < this.emails.length; index++) {
        const email = this.emails[index];
        if (email.email === "") {
          this.errorsModal.message = "Debe ingresar todos los correos";
          this.errorsModal.show = true;
          return;
        }
        if (email.type === "") {
          this.errorsModal.message = "Debe ingresar todos los tipos de correo";
          this.errorsModal.show = true;
          return;
        }
      }
      this.errorsModal.message = "";
      this.errorsModal.show = false;
      if (this.emails.length === 1) {
        this.isCardModalActive = false;
        return (this.email = `Se Agrego 1 correo`);
      }
      this.email = `Se Agregaron (${this.emails.length}) correos`;
      this.isCardModalActive = false;
    },
    acceptNewPhones() {
      for (let index = 0; index < this.phones.length; index++) {
        const phone = this.phones[index];
        if (phone.phone === "") {
          this.errorsModal.message = "Debe ingresar todos los telefonos";
          this.errorsModal.show = true;
          return;
        }
        if (phone.type === "") {
          this.errorsModal.message = "Debe ingresar todos los tipos de correo";
          this.errorsModal.show = true;
          return;
        }
      }
      this.errorsModal.message = "";
      this.errorsModal.show = false;
      if (this.phones.length === 1) {
        this.isCardModalActive = false;
        this.modalPhone = false;
        return (this.phone = `Se Agrego 1 telefono`);
      }
      this.phone = `Se Agregaron (${this.phones.length}) telefonos`;
      this.modalPhone = false;
      this.isCardModalActive = false;
    },
    acceptExtraInfo() {
      if (!validText(this.extraInfoData.title)) {
        this.errorsModalInfo.message = "Debe ingresar el título";
        this.errorsModalInfo = true;
        return;
      }

      if (!validText(this.extraInfoData.value)) {
        this.errorsModalInfo.message = "Debe ingresar el valor";
        this.errorsModalInfo = true;
        return;
      }

      this.extraInfoList.push({
        ...this.extraInfoData,
        added: true,
        order: this.extraInfoList.length + 1,
        index: this.extraInfoList.length + 1,
      });
      this.extraInfoData = {};
      this.modalInfo = false;
    },
    openModal(phone = null) {
      if (phone == "info") {
        this.modalInfo = true;
        this.modalPhone = false;
        this.isCardModalActive = false;
        return;
      }
      if (phone != null) {
        this.modalPhone = true;
        this.isCardModalActive = true;
        return;
      }
      this.modalPhone = false;
      this.isCardModalActive = true;
    },
    processExtraInfo() {
      const newList = this.extraInfoList.map((extra, index) => {
        return {
          value: extra.value,
          label: extra.title,
          line: index,
          unity: {
            code: extra.type,
          },
        };
      });
      return newList;
    },
    getObj() {
      const send = {
        code: this.idCompany,
        name: this.name,
        identification: `${this.identification}-${this.digit}`,
        identificationType: {
          code: this.idType,
        },
        telephone: JSON.stringify(this.phones),
        address: this.address,
        email: JSON.stringify(this.emails),
        latitude: this.latitude,
        longitude: this.longitude,
        cardId: !this.companyCode
          ? null
          : `${this.companyCode}|${this.parkingCode}`,
        classification: this.clasification,
        father:
          this.editing && !this.company
            ? null
            : {
                code: this.company,
              },
        location: {
          code: this.city.code,
        },
        infoList: this.processExtraInfo(),
      };
      if (this.clasification != "P") {
        delete send.infoList;
      }
      if (send.code === null) {
        delete send.code;
      }
      return send;
    },
    async save() {
      this.validationStarted = true;
      const validationResult = await this.$validator.validateAll();
      if (!validationResult) {
        this.toast("Debes completar el formulario", TOAST_TYPES.ERROR);
        return;
      }
      const send = this.getObj();
      this.isLoading = true;
      const fileCode = await this.uploadFile();
      if (fileCode == -1) {
        this.toast(
          "No se pudo subir el archivo correctamente",
          TOAST_TYPES.ERROR
        );
        return;
      }
      if (fileCode > 0) {
        send.logo = fileCode;
      }
      const method = this.editing ? "put" : "post";
      this.$http[method](ROUTES.DASHBOARD.SAVE_COMPANY, send)
        .then(({ data }) => {
          if (data.code > 0) {
            this.isLoading = false;
            this.toast(data.message, TOAST_TYPES.SUCCESS);
            this.cleanForm();
            return;
          }
          this.isLoading = false;
          this.toast(data.message, TOAST_TYPES.ERROR);
        })
        .catch((error) => {
          this.toast(
            "Se ha producido un error desconocido.",
            TOAST_TYPES.ERROR
          );
          this.isLoading = false;
        });
    },
    openDeleteModal() {
      confirmation(this, `¿Desea eliminar la empresa ${this.name}?`).then(
        (result) => {
          if (!result) {
            return;
          }
          this.deleteCompany();
        }
      );
    },
    deleteCompany() {
      this.isLoading = true;
      this.$http
        .delete(ROUTES.DASHBOARD.DELETE_COMPANY, { code: this.idCompany })
        .then(({ data }) => {
          this.isLoading = false;
          if (data.code > 0) {
            this.toast(data.message, TOAST_TYPES.SUCCESS);
            this.cleanForm();
            return;
          }
          this.isLoading = false;
          this.toast(data.message, TOAST_TYPES.ERROR);
        });
    },
    cleanForm() {
      this.validationStarted = false;
      this.name = "";
      this.phone = "";
      this.idType = "";
      this.identification = "";
      this.digit = "";
      this.email = "";
      this.infoLabel = "";
      this.address = "";
      this.latitude = "";
      this.longitude = "";
      this.company = null;
      this.clasification = "";
      this.city = null;
      this.extraInfoList = [];
      this.idCompany = null;
      this.emails = [
        {
          email: "",
          type: "",
          add: true,
        },
      ];
      this.phones = [
        {
          phone: "",
          type: "",
          add: true,
        },
      ];
      this.extraInfo = [
        {
          title: null,
          value: null,
          order: null,
          type: null,
          add: true,
        },
      ];
      this.modalPhone = false;
      this.isCardModalActive = false;
      this.errorsModal.message = "";
      this.errorsModal.show = false;
      this.errorsModalInfo.message = "";
      this.errorsModalInfo.show = false;
      this.editModal = false;
      this.modalInfo = false;
      this.consultName = "";
    },
    consultCompanies() {
      this.isLoading = true;
      this.$http
        .get(ROUTES.DASHBOARD.GET_SAVED_COMPANIES, {
          params: {
            criteria: this.consultName,
          },
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.isLoading = false;
            this.tableData = data.info;
            return;
          }
          this.tableData = [];
          this.isLoading = false;
          this.toast(data.message, TOAST_TYPES.ERROR);
        });
    },
    fillData(query = false) {
      const {
        name,
        identification,
        email,
        telephone,
        latitude,
        longitude,
        address,
        classification,
        father,
        identificationType,
        code,
        location,
        infoList,
        cardId,
      } = this.selected;
      this.lastFilled = query ? "query" : "modal";
      this.consultName = "";
      this.name = query ? null : name;
      this.phones = telephone ? JSON.parse(telephone) : [];
      this.idType = identificationType.code;
      const identificationParts = identification
        ? identification.split("-")
        : [];
      this.identification =
        identificationParts.length > 0 ? identificationParts[0] : "";
      this.digit =
        identificationParts.length == 2 ? identificationParts[1] : "";
      this.emails = email ? JSON.parse(email) : [];
      const parts = cardId != null ? cardId.split("|") : null;
      this.companyCode = parts ? parts[0] : null;
      this.parkingCode = parts ? parts[1] : null;
      if (Array.isArray(infoList) && infoList.length > 0) {
        this.extraInfoList = infoList.map((extra, index) => {
          return {
            title: extra.label,
            value: extra.value,
            type: extra.unity.code,
            order: extra.line,
            add: index === infoList.length - 1 ? true : false,
          };
        });
        this.infoLabel =
          this.extraInfo.length === 1
            ? "Se agrego 1 información"
            : `Se Agregaron (${this.extraInfo.length}) informaciones`;
      } else {
        this.extraInfoList = [];
      }
      this.address = address;
      this.$store.commit(mapTypes.mutations.setLongitude, longitude);
      this.$store.commit(mapTypes.mutations.setLatitude, latitude);
      this.company = query ? code : !father ? null : father.code;
      this.clasification = query ? null : classification;
      this.idCompany = query ? null : code;
      this.city = location.code;
      this.email =
        this.emails.length === 1
          ? "Se agrego 1 email"
          : `Se Agregaron (${this.emails.length}) correos`;
      this.phone =
        this.phones.length === 1
          ? "Se agrego 1 telefono"
          : `Se Agregaron (${this.phones.length}) telefonos`;
      this.tableData = [];
      if (location != null && Object.keys(location).length > 0) {
        this.cities = [location];
        this.processData(this.cities);
        this.city = location;
      } else {
        this.cities = [];
        this.city = null;
      }
      this.editModal = false;
    },
    closeEditModal() {
      this.editModal = false;
      this.consultName = "";
      this.tableData = [];
    },
    onCancelEditModal() {
      this.cleanForm();
      this.selected = null;
      this.tableData = [];
      this.consultName = "";
      this.editModal = false;
    },
    onCancelModalEmailPhone() {
      if (this.modalPhone) {
        this.modalPhone = false;
      }
      this.errorsModal.show = false;
      this.errorsModal.message = "";
      this.isCardModalActive = false;
    },
    getIdType({ code }) {
      const idType = this.idList.find((id) => id.code === code);
      return idType.title;
    },
  },
};
</script>
